import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import logoFooter from "../../assets/logoFooter.png";
import { getFirestore } from "../../config/firebase";
import { useLocation } from "react-router-dom";
import { getUtmParams, saveUtmParams } from "../../config/whatsappConfig";

const ICON_UBICACION = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: "middle" }}
  >
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"
      fill="#fff"
    />
  </svg>
);

const Footer = () => {
  const location = useLocation();
  const { utm_source, utm_medium } = getUtmParams();
  const utms = `?utm_source=${encodeURIComponent(utm_source)}&utm_medium=${encodeURIComponent(utm_medium)}`;

  const [redesSociales, setRedesSociales] = useState([]);

  useEffect(() => {
    saveUtmParams();
  }, [location.search]);

  useEffect(() => {
    const cargarDatos = async () => {
      const datosLocales = localStorage.getItem("redesSociales-hyundai");
      if (datosLocales) {
        setRedesSociales(JSON.parse(datosLocales));
      } else {
        const db = getFirestore();
        try {
          const datos = await db.collection("hyundai-informacion").get();
          const arrayDatos = datos.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setRedesSociales(arrayDatos[0]);
          localStorage.setItem("redesSociales-hyundai", JSON.stringify(arrayDatos[0]));
        } catch (error) {
          console.log(error);
        }
      }
    };
    cargarDatos();
  }, []);

  const urlActual = window.location.href;

  return (
    <>
      <Container fluid style={{ background: "#002c5a", color: "#fff", fontFamily: "inherit" }} className="pt-4">
        <Container>
          <Row className="align-items-center text-start text-md-start" style={{ minHeight: 80 }}>
            {/* Logo */}
            <Col xs={12} md={3} className="mb-3 mb-md-0 text-md-start text-start">
              <a href={`${urlActual}${utms}`}>
                <img src={logoFooter} alt="Automont Hyundai" style={{ maxWidth: "250px" }} />
              </a>
            </Col>
            {/* Dirección */}
            <Col xs={12} md={6} className="mb-3 mb-md-0 text-start  pt-md-0 pt-3">
              <span style={{ fontWeight: 300, fontFamily: "FuturaPTMedium", width: "170px" }}>Visítanos en: </span>
              <div className="pt-md-0 pt-3">
                <span style={{ margin: "0 8px", verticalAlign: "middle" }}>{ICON_UBICACION}</span>
                <span style={{ textDecoration: "underline", fontFamily: "FuturaPTLight" }}>
                  Av. Emilio Caraffa 1868 - Córdoba Capital
                </span>
              </div>
            </Col>
            {/* Redes sociales */}
            <Col xs={12} md={3} className="text-md-end text-start pt-4">
              <span style={{ fontWeight: 300, fontFamily: "FuturaPTMedium" }}>Seguinos en: </span>
              {redesSociales.redes &&
                redesSociales.redes.map((red) =>
                  red.disponible ? (
                    <a key={red.url} href={red.url} target="_blank" rel="noreferrer" className="ms-2 d-inline-block">
                      <img src={red.url_icon} alt="Logo" style={{ width: 24, height: 24, verticalAlign: "middle" }} />
                    </a>
                  ) : null
                )}
            </Col>
          </Row>
          <Row className="mt-2 pb-4 pt-4">
            <Col className="text-start">
              <p style={{ margin: 0, fontSize: 13, fontWeight: 300, fontFamily: "FuturaPTLight" }}>
                El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado de forma parcial o
                total sin previo aviso.
              </p>
            </Col>
          </Row>
        </Container>

        <Row className="mt-2" style={{ background: "#fff", padding: 16 }}>
          <Col className="text-center">
            <p style={{ margin: 0, fontSize: 14, opacity: 0.8, color: "#000", fontFamily: "FuturaPTLight" }}>
              Copyright © {new Date().getFullYear()} Montironi Hyundai - Todos los derechos reservados - Políticas de
              Seguridad
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
